import { useState } from "react";

export const useIsValidatingUser = () => {

    const [isValidating, setIsValidating] = useState(true);

    return {
        isValidating,
        setIsValidating
    };
};
